var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/modules/_an-object.js
// module id = 42
// module chunks = 168707334958949